// @flow

import type { PropsSchema, BasicProps } from '../../type'
import type { Rules } from 'frame/core/formValidate'
import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  field: string,
  isDefaultChecked: boolean,
  rules: Rules,
  formValues: { [string]: string },
  customProps: any,
  setFormValues: ({ [key: string]: any }) => void
};

@computeData()
export default class InputText extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      key: 'field',
      title: '字段',
      type: 'text'
    },
    {
      type: 'boolean',
      key: 'isDefaultChecked',
      title: '是否默认勾选'
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: '改变',
      event: 'onChange'
    }
  ];

  componentDidMount () {
    this.setChecked(this.props.isDefaultChecked)
  }

  componentDidUpdate (preProps: Props) {
    let { callActions, isDefaultChecked } = this.props
    if (isDefaultChecked !== preProps.isDefaultChecked) {
      this.setChecked(isDefaultChecked)
    }
    if (this.getFieldValue(preProps) !== this.getFieldValue()) {
      callActions('onChange', this.getFieldValue())
    }
  }

  getFieldValue = (props?: Props): boolean => {
    const { field, formValues } = props || this.props
    return !!formValues[field]
  };

  setChecked = (checked?: boolean) => {
    let { field, setFormValues } = this.props
    setFormValues({ [field]: checked })
  };

  onChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.setChecked(event.currentTarget.checked)
  };

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, style, field, formValues } = this.props
    return (
      <input
        name={field}
        type='checkbox'
        checked={!!formValues[field]}
        onChange={this.onChange}
        style={style}
        id={id}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/FormCheckbox.js